const informationPermiso = async (props) =>{
  const req = await fetch('https://api.ingresos-guerrero.gob.mx/pasarela/permiso', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(props)
  });
  try {
    const json = await req.json();
    return {
      acept: req.status === 200,
      body: json,
      message: req.status !== 200 ? json.message : ''
    };
  } catch (error) {
    return {
      acept: req.status === 200,
      message: 'Error inesperado'
    };
  }
  
}

export default informationPermiso;